import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import momentPropTypes from 'react-moment-proptypes';
import ProgressButtons from './ProgressButtons';
import {
  getSelectedReports,
  getCheckedReports,
  getReports,
} from '../../target-node-report-selector/redux/selectors/ReportsSelectors';
import SelectionCriteriaReportSelector from '../../target-node-report-selector/components/SelectionCriteriaReportSelector';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../period-selector/redux/selectors/PeriodSelectionSelectors';
import {
  reportsCheckedActionCreator,
  onDeSelectAllReports,
  onSelectAllReports,
  retrieveOutboundReportsRequestActionCreator,
} from '../../target-node-report-selector/redux/actions/ReportsActions';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
/* eslint-disable import/no-cycle */
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import noop from '../../../../core/modules/common/tools/noop';

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundReportsRequestActionCreator,
  reportsCheckedActionCreator,
  onSelectAllReports,
  onDeSelectAllReports,
}, dispatch);

const mapStateToProps = state => ({
  selectedReportsNodes: getSelectedReports(state),
  reportsNodes: getReports(state),
  checkedReports: getCheckedReports(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
});

// eslint-disable-next-line react/prefer-stateless-function
class TargetNodeReportWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstReport: true,
      selectionTreeLoaded: false,
      showOnlySelectedReports: false,
    };
  }

  componentDidMount() {
    this.props.retrieveOutboundReportsRequestActionCreator({
      startDate: this.props.startDate,
      endDate: this.props.endDate,
    }, this.props.checkedReports);
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedReportsNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstReport && this.props.reportsNodes === nextProps.reportsNodes && nextProps.selectedReportsNodes.length !== 0) {
      this.setState({
        firstReport: false,
        showOnlySelectedReports: true,
      });
    }

    await this.props.reportsNodes;
    this.setState({
      selectionTreeLoaded: this.props.reportsNodes.length > 0,
    });
  }

  onSelectAllReports = () => {
    this.props.onSelectAllReports(this.props.reportsNodes);
  };

  onDeSelectAllReports = () => {
    this.setState({
      showOnlySelectedReports: false,
    });
    this.props.onDeSelectAllReports();
  };

  onSelectReport = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedReports: false,
      });
    } else {
      this.setState({
        firstReport: false,
      });
    }
    this.props.reportsCheckedActionCreator(selected);
  };

  onToggleShowOnlySelectedReports = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedReports: !this.state.showOnlySelectedReports,
    });
  };

  render() {
    const tempNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.checkedReports && this.props.checkedReports.length > 0 ? this.props.checkedReports.map(initialItem => ({ value: initialItem, label: '', iataCode: '' })) : [],
      }];
    const reportsSelectorProps = {
      selected: this.props.checkedReports,
      // eslint-disable-next-line max-len
      isShowOnlySelected: !this.state.selectionTreeLoaded ? true : this.state.showOnlySelectedReports,
      // eslint-disable-next-line max-len,no-nested-ternary
      reportsNodes: !this.state.selectionTreeLoaded ? tempNodes : this.state.showOnlySelectedReports ?
        this.props.selectedReportsNodes : this.props.reportsNodes,
      onSelect: !this.state.selectionTreeLoaded ? noop : this.onSelectReport,
      onSelectAll: !this.state.selectionTreeLoaded ? noop : this.onSelectAllReports,
      onDeSelectAll: !this.state.selectionTreeLoaded ? noop : this.onDeSelectAllReports,
      // eslint-disable-next-line max-len
      onShowOnlySelected: !this.state.selectionTreeLoaded ? noop : this.onToggleShowOnlySelectedReports,
      openSaveSelectionModal: !this.state.selectionTreeLoaded ? noop : this.openSaveSelectionModal,
    };

    const selectionCriteria = this.props.children.report.selectionCriteria.items;
    const SC_CODE = sc.SC051;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <SelectionCriteriaReportSelector
                title="REPORTS"
                {...reportsSelectorProps}
              />
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>);
  }
}

TargetNodeReportWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundReportsRequestActionCreator: PropTypes.func,
  selectedReportsNodes: PropTypes.arrayOf(PropTypes.object),
  reportsNodes: PropTypes.arrayOf(PropTypes.object),
  checkedReports: PropTypes.arrayOf(PropTypes.string),
  reportsCheckedActionCreator: PropTypes.func,
  onSelectAllReports: PropTypes.func,
  onDeSelectAllReports: PropTypes.func,
  setDirections: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeReportsWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetNodeReportWizardContainer);

export default (ConnectedTargetNodeReportsWizardContainer);
